import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type MarketRoute from 'lumen/routes/market';
import type { Transition } from 'lumen/services/transition';
import type { ModelFrom } from 'lumen/utils/routes';

type Model = ModelFrom<MarketRoute>;

export default class MarketParityRoute extends Route {
  @service declare router: Services['router'];

  redirect(model: Model, transition: Transition): void {
    if (transition.targetName === 'market.parity.index') {
      this.router.transitionTo('market.parity.insight');
    }
  }
}
